export default "__VITE_ASSET__50a0f0e3__"